/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import ShowVideo from "./show-video";
import { useDispatch, useSelector } from "react-redux";
import { getProfileVideosAction } from "../../../../store/ProfileVideoActions";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { useAxiosInstance } from "../../../../services/Interceptor";
import LoadingSpinner from "../../../../components/LoadingSpinner";
import AddProfileVideoWeightRoom from "./add-video";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

export default function ProfileVideo() {
  const dispatch = useDispatch();
  const r_profileVideo = useSelector((state) => state.profileVideo);
  const auth = useAuthUser();
  const apiInstance = useAxiosInstance();
  const [isOpen, setIsOpen] = useState(false);
  const [profileVideos, setProfileVideos] = useState([]);

  useEffect(() => {
    if (!r_profileVideo.reload) {
      dispatch(getProfileVideosAction(apiInstance, auth.user.id));
    }
  }, [dispatch, r_profileVideo.reload]);

  useEffect(() => {
    const results = r_profileVideo.profileVideos.filter(
      (item) => item.type === 6,
    );
    setProfileVideos(results);
  }, [r_profileVideo.profileVideos]);

  return (
    <>
      <div className="relative">
        {r_profileVideo.loading && (
          <div className="absolute top-0 left-0 bg-white/75 w-full h-full pt-24">
            <LoadingSpinner />
          </div>
        )}

        <div className="mt-4">
          <div
            className="float-right text-sm text-white border border-gray-300 p-2 rounded  bg-blue-600 hover:bg-blue-800   cursor-pointer"
            onClick={() => setIsOpen(true)}
          >
            <FontAwesomeIcon icon={faPlus} /> Add new record
          </div>
          <h2 className="font-medium mb-4 uppercase">Weight Room</h2>
          <div className="clear-both"></div>
        </div>
        <div className="clear-both"></div>

        {profileVideos.length > 0 ? (
          <div className="w-full mx-auto border border-blue-700 rounded items-center p-4 mt-2 h-[700px] overflow-auto">
            <div className="w-full mx-auto">
              {profileVideos.map((item, key) => (
                <div
                  key={key}
                  className="odd:bg-[#E6E3E3] flex justify-between items-center p-3 "
                >
                  <span>
                    {item.title} / {item.weight} lbs / {item.reps} reps
                  </span>
                  <>
                    <ShowVideo profileVideo={item} />
                  </>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="bg-blue-100 border border-blue-300 text-blue-800 p-2">
            There are no records to display
          </div>
        )}
      </div>
      <AddProfileVideoWeightRoom
        isOpen={isOpen}
        setIsOpen={() => setIsOpen(false)}
      />
    </>
  );
}
